import { composeReducers } from 'common/util/composeReducers';

import {
    EVENT_TYPES_LOAD,
    CUSTOM_EVENT_TYPE_LOAD,
    CUSTOM_EVENT_TYPE_UNLOAD,
    EVENT_TYPES_UNLOAD,
    EVENT_TYPES_TOGGLE,
    EVENT_TYPES_CREATE,
    GET_DATA_SOURCES,
    REMOVE_DATA_SOURCES,
} from 'common/actions/eventTypes';

export function getInstitutionEventTypes(state, action) {
    if (!action || action.type !== EVENT_TYPES_LOAD) {
        return state;
    }
    return {
        ...state,
        eventTypes: action.payload,
    };
}

export function clearInstitutionEventTypes(state, action) {
    if (!action || action.type !== EVENT_TYPES_UNLOAD) {
        return state;
    }
    return {
        ...state,
        eventTypes: []
    };
}

export function createEventType(state, action) {
    if (!action || action.type !== EVENT_TYPES_CREATE) {
        return state;
    }

    return {
        ...state,
    };
}

export function getDataSource(state, action) {
    if (!action || action.type !== GET_DATA_SOURCES) {
        return state;
    }

    const formattedDataSources = action.payload.map(formatDataSource);

    return {
        ...state,
        dataSources : formattedDataSources,
    };
}

export function removeDataSource(state, action) {
    if (!action || action.type !== REMOVE_DATA_SOURCES){
        return state;
    }
    const newState = {...state};
    delete newState.dataSources;

    return newState;
}

function formatDataSource(dataSource){
    return {
        value : dataSource.name,
        id : dataSource.id,
        label : dataSource.name,
        parameters : dataSource.parameters,
    };
}

export function toggleInstitutionEventType(state, action) {
    if (!action || action.type !== EVENT_TYPES_TOGGLE) {
        return state;
    }
    const { payload: updatedEventType } = action;
    const { eventTypes } = state;
    const newEventTypes = eventTypes.map(eventType => {
        const newEventType = {
            ...eventType
        };
        if (updatedEventType.id === newEventType.id) {
            newEventType.isEnabled = updatedEventType.isEnabled;
        }
        return newEventType;
    });
    return {
        ...state,
        eventTypes: newEventTypes
    };
}

export function getCustomEventType(state, action) {
    if (!action || action.type !== CUSTOM_EVENT_TYPE_LOAD) {
        return state;
    }
    return {
        ...state,
        customEventType: action.payload,
    };
}

export function unloadCustomEventType(state, action) {
    if (!action || action.type !== CUSTOM_EVENT_TYPE_UNLOAD) {
        return state;
    }
    return {
        ...state,
        customEventType: action.payload,
    };
}


export default composeReducers(
    getInstitutionEventTypes,
    clearInstitutionEventTypes,
    toggleInstitutionEventType,
    createEventType,
    getDataSource,
    removeDataSource,
    getCustomEventType,
    unloadCustomEventType,
);
